<template>
  <header class="header">
    <BannerMain/>
  </header>
</template>
<script>
import BannerMain from "@/components/header/BannerMain";

export default {
  name: "HeaderLayout",
  components: {BannerMain},
}
</script>
<style lang="scss">
.header {
  position: relative;
  height: 100vh;
  width: 100vw;
  background: url(~@/assets/BG-2-mob.png) no-repeat center;
  background-size: cover;
  overflow: hidden;

  @include _576 {
    background: url(~@/assets/BG-2.png) no-repeat center right;
    background-size: cover;
  }

  @include _768 {
    &:after {
      content: none;
    }
  }

  &:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5;
  }

}
</style>